import { PermissionGuard } from '@/auth/guard';
import { OrionAccess, OrionModule, OrionSubmodule } from '@/types';
import {
  SkuListPage,
  SkuEditPage,
  SkuPlansPage,
  SkuCreatePage,
  SkuInformationPage,
} from './imports';

export const skuRoutes = [
  {
    path: 'skus',
    children: [
      {
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.SKU}
            access={OrionAccess.VIEW}
          >
            <SkuListPage />
          </PermissionGuard>
        ),
        index: true,
      },
      {
        path: 'list',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.SKU}
            access={OrionAccess.VIEW}
          >
            <SkuListPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/information',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.PARTNER.SKU}
            access={OrionAccess.VIEW}
          >
            <SkuInformationPage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/plans',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.ACCOUNT}
            submodule={OrionSubmodule.PARTNER.PLAN}
            access={OrionAccess.VIEW}
          >
            <SkuPlansPage />
          </PermissionGuard>
        ),
      },
      {
        path: 'new',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.SKU}
            access={OrionAccess.CREATE}
          >
            <SkuCreatePage />
          </PermissionGuard>
        ),
      },
      {
        path: ':id/edit',
        element: (
          <PermissionGuard
            hasContent
            module={OrionModule.PARTNER}
            submodule={OrionSubmodule.PARTNER.SKU}
            access={OrionAccess.UPDATE}
          >
            <SkuEditPage />
          </PermissionGuard>
        ),
      },
    ],
  },
];
